import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { PageHero } from "../../components/public/Section";
import { api } from "../../lib/api";
import { ArrowLeft } from "lucide-react";
import HorizontalGallery from "../../components/public/HorizontalGallery";

export default function GalleryAlbum() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/gallery/albums/${slug}`).then((r) => setData(r.data)); }, [slug]);
  if (!data) return <div className="section container-wide text-center text-brand-muted">Loading…</div>;
  return (
    <div>
      <PageHero title={data.album.title} subtitle={data.album.description} breadcrumbs={["Home", "Gallery", data.album.title]} />
      <section className="section">
        <div className="container-wide flex items-center justify-between flex-wrap gap-4 mb-10">
          <Link to="/gallery" className="btn-ghost"><ArrowLeft size={16} /> All Albums</Link>
          <div className="text-sm text-brand-muted">{data.items.length} items · drag or scroll to browse →</div>
        </div>
        <div className="pl-[max(1rem,calc((100vw-1440px)/2+2.5rem))] pr-4">
          <HorizontalGallery items={data.items} testidPrefix="gallery-item" />
        </div>
      </section>
    </div>
  );
}
